import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';
import { PageviewsettingsService } from 'src/app/services/pageviewsettings.service';
import { TenantService } from '../../services/tenant.service';
import * as Globals from '../../../globals';
import { URL_INTERCOM_SUPPORT } from 'src/globals';

declare let analytics: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent {
	logoUrl = '/assets/Logo_Final.png';
	tenantName: string = window.location.href.split('/')[3]; // TODO: Find a better way to do this.
	loadeddata: any;
	affiliateId: any;
	tenant: TenantService;
	public generalSupportURL: string = URL_INTERCOM_SUPPORT;

	plans:{name: string, list: {name: string, url: string}[]}[] = [
    {
      name: 'Plans',
      list: [
        {name: 'Fan Plans', url: 'huskymobile/fan'},
        {name: 'Student Plans', url: 'huskymobile/student'},
        // {name: 'Faculty Plans', url: '/help'},
        
      ]
    },
  ]

	facultyEnabled = false; // True after the user visits the Faculty Page via direct URL which will set the local storage key: facultyEnabled.
	collegeName: any | undefined;
	tenantId: number | undefined;
	collegemobile: string | undefined;

   constructor(
			private router: Router,
			private route: ActivatedRoute,
			private settingsService: PageviewsettingsService,
			private modalService: ModalService,
			private cdr: ChangeDetectorRef,
			private tenantService: TenantService) {
		this.tenant = tenantService;

        this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				let currentRoute = this.route;
				while (currentRoute.firstChild) {
					currentRoute = currentRoute.firstChild;
				}

				this.collegemobile = currentRoute.snapshot.paramMap.get('collegemobile') || 'huskymobile';
				this.collegeName = this.collegemobile;
		
				this.settingsService.getCollegetenantcode(this.collegeName).subscribe(data => {
					this.tenantId = parseInt(data.result.id);
					this.affiliateId = data.result.affiliateId

					this.loadPageSettings();
				});
			}
		});

		this.facultyEnabled = this.tenant.getFacultyVisibility();

		this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(() => {
			const flag = this.tenant.getFacultyVisibility();
			if (flag !== this.facultyEnabled) {
				this.facultyEnabled = flag;
				this.cdr.detectChanges();
			}
		});
      }

	getSocialUrl (social: string) {
		switch (this.tenantId ) {
		case 1: 
			switch (social) {
			case 'facebook' : return 'https://www.facebook.com/people/Husky-Mobile/61578712507415/'
			case 'instagram' : return 'https://www.instagram.com/gohuskymobile/';
			default: return '';
			}
		case 2: 
			switch (social) {
			case 'facebook' : return 'https://www.facebook.com/profile.php?id=61579388472055'
			case 'instagram' : return 'https://www.instagram.com/gobearsmobile/';
			default: return '';
			}
		case 3: 
			switch (social) {
			case 'facebook' : return 'https://www.facebook.com/profile.php?id=61579378902391'
			case 'instagram' : return 'https://www.instagram.com/beavsmobile/';
			default: return '';
			}
		default: return '';

		}
	}

    loadPageSettings() {
		this.settingsService.getPageViewSettings(this.affiliateId, this.tenantId).subscribe(data => {
			this.loadeddata = data.result;
			const color = this.loadeddata?.PrimaryColor;
	
			if (color) {
				document.documentElement.style.setProperty('--primary', color);
			} else {
				document.documentElement.style.setProperty('--primary', 'white');
			}
      });
    }

	trackclick(event:any){
		analytics.track(event)
	} 

}
